var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAudience(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 78,
    viewBox: "0 0 157 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.6876 19.5618C97.6876 30.0216 89.2087 38.5013 78.7482 38.5013C68.2883 38.5013 59.8096 30.0214 59.8096 19.5618C59.8096 9.10197 68.2886 0.622314 78.7482 0.622314C89.2089 0.622314 97.6876 9.10219 97.6876 19.5618Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.124 77.3772H39.376C39.376 57.4405 50.8388 44.9797 64.7939 40.494C68.7809 42.9856 73.7651 44.4811 78.7493 44.4811C83.7336 44.4811 88.2192 42.9856 92.2063 40.494C106.162 44.9797 118.122 57.4396 118.122 77.3772H118.124Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.599 11.0907C134.072 11.0907 140.551 18.0679 140.551 26.5417C140.551 35.0144 134.072 41.4941 125.599 41.4941C117.126 41.4941 110.646 35.0144 110.646 26.5417C110.646 18.069 117.126 11.0907 125.599 11.0907Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.998 72.8916H121.113C120.116 61.9263 115.631 52.955 108.653 45.9778C110.647 44.9808 112.64 43.9838 114.634 42.9877C117.625 45.4792 121.612 46.4764 125.6 46.4764C129.587 46.4764 133.574 45.4794 136.565 42.9877C148.028 46.9747 156.999 56.9432 156.999 72.8912L156.998 72.8916Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4007 11.0907C23.4263 11.0907 16.4482 18.0679 16.4482 26.5417C16.4482 35.0144 23.4254 41.4941 31.4007 41.4941C39.8734 41.4941 46.8517 35.0144 46.8517 26.5417C46.8517 18.069 39.8745 11.0907 31.4007 11.0907Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00112141 72.8916H35.8862C36.8832 61.9263 41.3688 52.955 48.8446 45.9778C46.8506 44.9808 44.8575 43.9838 42.3648 42.9877C39.3747 45.4792 35.3877 46.4764 31.3995 46.4764C27.4124 46.4764 23.9237 45.4794 20.4341 42.9877C9.46873 46.9747 0 56.9432 0 72.8912L0.00112141 72.8916Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudience);
export default __webpack_public_path__ + "static/media/Audience.d21b2c5e6f61e345a5f0eb4178332173.svg";
export { ForwardRef as ReactComponent };